import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// forms
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VideoModalComponent } from './video-modal/video-modal.component';


@NgModule({
  declarations: [
    VideoModalComponent,
   
  ],
  imports: [
    CommonModule,  
    FormsModule,
    ReactiveFormsModule,
  
  ],
  exports:
  [
    VideoModalComponent
   
  ],
  entryComponents:
  [
    VideoModalComponent,
  
  ]
})
export class ModalesModule { }
